import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner,SimpleGrid,Center,Box,Button,Text,Input,FormControl,Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton,useDisclosure,useToast, Image} from '@chakra-ui/react';



type Props = {
  isOpen:boolean,
  onClose:any,
}

export const LoadingModal: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();

  return (
    <>
      <Modal 
        isCentered 
        isOpen={props.isOpen} 
        onClose={props.onClose} 
        closeOnOverlayClick={false}
      >
            <ModalOverlay
                backdropFilter='blur(15px)'
            />
            <ModalContent
              width={''}
              bg={''}
              shadow={''}
            >
              <Center>
                <Spinner 
                    thickness='4px'
                    speed='0.65s'
                    emptyColor='gray.200'
                    color='blue.500'
                    size='xl'
                />
              </Center>
              <Center>
                <Text 
                  color={'white'}
                  fontWeight={'bold'}
                >{t(`待機中`)}</Text>
              </Center>
            </ModalContent>
      </Modal>
    </>
  );
};